import { GridNineIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const GridSystem = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <GridNineIcon {...rest} size={Sizes[size]} color={fill} />;
};

GridSystem.displayName = 'GridSystem';
